import { createIntl, createIntlCache } from "@formatjs/intl";

const intl = createIntl(
  {
    locale: "zh-CN",
    messages: {},
  },
  createIntlCache()
);

/**金额格式化 */
export const priceFormat = (num, n = 2) => {
  return intl.formatNumber(num, {
    minimumFractionDigits: n,
  });
};

/**科学计数法 */
export const numberFormat = (value) => {
  return priceFormat(value, 0);
};

/**银行账号中间部分用星号代替 */
export const bankAccountFormat = (value) => {
  if (!value) return "-";

  if (value?.length >= 8) {
    return value.substring(0, 4) + "***" + value.substring(value.length - 4);
  } else {
    return "卡号错误";
  }
};
